import { snakeCase } from 'snake-case';

import { DELIVERY_TYPES } from '../DeliveryTypeButton/constants';

export const deliveryTypes = Object.values(DELIVERY_TYPES).map(snakeCase);
